import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AceEditorModule} from '../../../../ace-edit-wrapper/src/ace-edit-wrapper.module';
import {MonacoEditorModule} from '../../../../monaco-editor-wrapper/src/monaco-editor-wrapper.module';
import {MonacoTextComponent} from './monaco-text.component';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {FormbirdServicesModule} from '../../../../formbird-services/src/lib/formbird-services.module';
import { default as pjson } from '../../../../../package.json';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';

@NgModule({
  imports: [
    CommonModule,
    FormbirdServicesModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    AceEditorModule,
    MonacoEditorModule,
    MatFormFieldModule,
    MatInputModule,
    ComponentSetupModule
  ],
  exports: [
    MonacoTextComponent
  ],
  declarations: [
    MonacoTextComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: []
})

export class MonacoTextModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(MonacoTextComponent, 'sc-monaco-text', this.injector, pjson.version);

  }
}
